import { Outlet } from "react-router-dom";
import globalStyles from "../../assets/styles/base/globalPage.module.scss";

export const AccountingLayout = ({ beta = false }) => {
  return (
    <div
      className={`${globalStyles?.pagePaddings} ${globalStyles.pageColumnGaps}`}
    >
      {beta ? <></> : <h3 className="font-weight-semibold">Reports</h3>}

      <Outlet />
    </div>
  );
};
